import { createStyles, makeStyles, Theme } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';

import { TextSizesEnum } from '../../../theme';
import { PlexTypographyEllipsed } from '../../shared/primitives/PlexTypographyEllipsed';
import { getTextColor } from './colors';

interface Props {
  className?: string;
  text: string;
  textColor?: string;
  backgroundColor: string;
}

export function BubbleText(props: Props): React.ReactElement {
  const { text, className } = props;
  const classes = useStyles(props);

  return (
    <div>
      <PlexTypographyEllipsed
        className={classNames(classes.root, className)}
        text={text}
        tooltip={text}
        size={TextSizesEnum.Small}
      />
    </div>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: ({ textColor, backgroundColor }: Props) => ({
      color: textColor || getTextColor(backgroundColor),
      backgroundColor,
      borderRadius: 18,
      padding: '4px 12px',
      height: '100%',
      fontWeight: 500,
    }),
  })
);
